(function ($) {
	'use strict';

	var initbackToTop = function () {
		var $backBtn = $('.back-to-top-btn', this);

		$backBtn.click(function () {
		$('body,html').stop(true, false).animate({
			scrollTop: 0
		}, 500);
		});
	};

	/**
	 * This is boilerplate: add a behavior to window.DP.behaviors
	 */
	window.DP.behaviors.backToTop = {
		attach: function (context) {
			$(context).find('.cc--back-to-top').once('backToTop').each(function () {
				initbackToTop.apply(this);
			});
		}
	};

})(jQuery);
